import React from 'react';
import { Section, Title, Entry, List } from '../Section';
import styles from '../Resume.module.scss';

const list = [
    <>
        <b>Languages &amp; Styling:</b> TypeScript, JavaScript, HTML, CSS/SCSS, Sass, Tailwind CSS, styled-components
    </>,
    <>
        <b>Frontend &amp; Architecture:</b> React, React Hooks, NextJS, React Query, React Context, Redux, Storybook, GraphQL, REST APIs,
        Electron
    </>,
    <>
        <b>Testing &amp; Quality:</b> Jest, React Testing Library, Cypress, MSW, Mocha, Selenium, SonarQube
    </>,
    <>
        <b>Build &amp; Delivery:</b> Git, Vite, Webpack, GitHub Actions, CI/CD, Jenkins, Docker, Kubernetes
    </>,
    <>
        <b>Cloud &amp; Observability:</b> Azure, AWS, GCP, Sentry, Opsgenie, Firebase Analytics
    </>,
    <>
        <b>Engineering Practices:</b> Component Architecture, Design Systems, Responsive UI, Performance Optimization, Feature Flags, i18n,
        Figma
    </>,
    <>
        <b>AI-Assisted Development:</b> GitHub Agents, GitHub Copilot, OpenAI Codex, Anthropic Claude, Ollama
    </>
];

const machineReadableSkills = [
    {
        category: 'Version Control Platforms',
        skills: ['Git', 'GitHub', 'GitLab', 'Bitbucket']
    },
    {
        category: 'Backend Development',
        skills: ['Node', 'NodeJS', 'NodeJS', 'Express', 'ExpressJS', 'NestJS', 'C#', '.NET', 'ASP.NET Core', 'Python', 'Microservices']
    },
    {
        category: 'Frontend Libraries and State Management',
        skills: ['Material UI', 'MUI', 'MobX', 'Redux Toolkit']
    },
    {
        category: 'Cloud and Serverless',
        skills: [
            'S3',
            'Amazon S3',
            'AWS S3',
            'Blob Storage',
            'Azure Blob Storage',
            'AWS Lambda',
            'Google Cloud',
            'Google Cloud Platform',
            'Firebase'
        ]
    },
    {
        category: 'Infrastructure and Orchestration',
        skills: ['K8s']
    },
    {
        category: 'Developer Tooling',
        skills: ['ES5', 'ES6', 'Babel', 'ESLint', 'npm', 'Sass', 'Prettier']
    },
    {
        category: 'Web Standards',
        skills: ['HTML5', 'CSS3']
    },
    {
        category: 'Testing and Engineering Practices',
        skills: ['Automated Testing', 'Unit Testing', 'Integration Testing', 'End-to-End Testing', 'E2E Testing', 'SOLID']
    },
    {
        category: 'Delivery Practices',
        skills: ['CICD', 'CI/CD']
    },
    {
        category: 'Databases and Data Stores',
        skills: ['SQL', 'NoSQL', 'PostgreSQL', 'MongoDB', 'Redis']
    },
    {
        category: 'API, Security and Accessibility',
        skills: ['Swagger', 'OAuth', 'JWT', 'Accessibility']
    },
    {
        category: 'Analytics and Tag Management',
        skills: ['Tealium', 'Adobe Analytics']
    },
    {
        category: 'AI Concepts',
        skills: ['LLM']
    },
    {
        category: 'AI Agent Development',
        skills: ['MCP Server', 'Model Context Protocol', 'MCP', 'Skills', 'Agent Skills', 'Loop', 'Agent Loop']
    },
    {
        category: 'Work Management',
        skills: ['Jira', 'Agile', 'Scrum', 'Kanban']
    }
];

export const FrontendSkills = ({ ...props }) => {
    return (
        <Section {...props}>
            <Entry>
                <Title id='skills'>Technical Skills</Title>
                <Entry>
                    <List list={list} narrow />
                    <div className={styles.machineReadableSkills} aria-label='Additional machine-readable technical skills'>
                        <h3>Additional Technical Skills</h3>
                        {machineReadableSkills.map(({ category, skills }) => (
                            <p key={category}>
                                <strong>{category}:</strong> {skills.join(', ')}
                            </p>
                        ))}
                    </div>
                </Entry>
            </Entry>
        </Section>
    );
};
